import React, { Children, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "../preguntasFrecuentes/Search";
import Glide from "@glidejs/glide";
/* import grupos from '../../../../data/grupos.json'; */

import getDate from "../../../../../helpers/getDate";

export const GruposFinalizados = props => {
    let newdate = new Date();
    let date = getDate(newdate);
    const [grupos, setgrupos] = useState({});
    const [loading, setloading] = useState(true);

    // number es lo que recibimos del search
    const [number, setNumber] = useState("");

    useEffect(() => {
        const asyncFunction = async () => {
        const endpoint = await (await fetch('/api/show_endpoints/WSGruposFinalizados')).json();
        const brand = await (await fetch('/api/get_brand')).json();

        fetch(
            `${endpoint.url_base}${endpoint.url_variable}?Brand=${brand.nombre}&Periodo=${date}`,
            {
                cache: 'no-cache'
            }
        )
            .then(response => response.json())
            .then(json => {
                setgrupos(json);
                setloading(false);
            });
        }
        asyncFunction();
    }, []);

    let array;
    let arregloDeArreglos = [];

    if (loading == false) {
        array = grupos;

        if (number == "") {
            if (array.length != 0) {
                for (let i = 0; i < array.length; i += 10) {
                    let pedazo = array.slice(i, i + 10);
                    arregloDeArreglos.push(pedazo);
                }
            }
        } else {
            let gruposEncontrados = array.filter(grupo => {
                return grupo.Grupo.toString().includes(number);
            });

            if (gruposEncontrados.length != 0) {
                for (let i = 0; i < gruposEncontrados.length; i += 10) {
                    let pedazo = gruposEncontrados.slice(i, i + 10);
                    arregloDeArreglos.push(pedazo);
                }
            }
        }
    }

    //esto se setea para saber en que breakpoint estamos y hacer el cambio en la descripcion que se muestran junto a la flechas de slider, grupo 1 a 70 de 100 por ejemplo
    const [size, setSize] = useState(window.innerWidth);
    window.addEventListener("resize", () => {
        setSize(window.innerWidth);
    });

    //parrafos se usa para poner el total de numeros que se muestran junto con las flechas de slider
    const [parrafos, setParrafos] = useState("");

    let calc = Math.round(parrafos / 10);

    const [perView, setperView] = useState("");

    useEffect(() => {
        if (size > 768) {
            if (calc >= 5) {
                setperView(5);
            } else {
                setperView(calc);
            }
        }

        if (size > 600 && size < 768) {
            if (calc >= 3) {
                setperView(3);
            } else {
                setperView(calc);
            }
        }

        if (size < 600) {
            setperView(1);
        }
    }, [size, calc]);

    const [hasta, sethasta] = useState("");
    const [desde, setdesde] = useState(1);

    useEffect(() => {
        let li = document.querySelectorAll(".sliderInfo--ul li");
        if (li.length > 1) {
            let newLi = [];

            for (let index = 0; index < perView; index++) {
                newLi.push(li[index]);
            }

            let child = 0;
            for (let index = 0; index < newLi.length; index++) {
                if (newLi[index] != undefined) {
                    child = child + newLi[index].children.length;
                }
            }
            sethasta(child);
        } else {
            sethasta(parrafos);
        }

        let p = document.querySelectorAll(".sliderInfo--ul li p");

        setParrafos(p.length);

        //slider

        let glides = document.querySelectorAll(".sliderInfo");

        for (var i = 0; i < glides.length; i++) {
            let glide = new Glide(glides[i], {
                gap: 0,
                animationDuration: 300,
                perView: calc >= 5 ? 5 : calc,
                bound: true,
                breakpoints: {
                    600: {
                        perView: 1
                    },
                    768: {
                        perView: calc >= 3 ? 3 : calc
                    },
                    992: {
                        perView: calc >= 5 ? 5 : calc
                    }
                }
            });

            glide.on("run", function(e) {
                const a = document.querySelector(".a");
                const de = document.querySelector(".de");

                //logica segun cada breakpoint del
                if (size < 600) {
                    a.innerHTML = glide.index * 10 + 10;
                    console.log(glide.index);
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                } else if (size > 600 && size < 768) {
                    a.innerHTML = glide.index * 10 + 30;
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                    if (hasta <= 10) {
                        de.innerHTML = 1;
                    }
                } else if (size > 768) {
                    a.innerHTML = glide.settings.perView * 10 + 10;
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                    if (hasta <= 10) {
                        de.innerHTML = 1;
                    }
                }
                if (glide.index == 0) {
                    de.innerHTML = 1;
                    a.innerHTML = hasta;
                }
            });

            glide.mount();
            return () => glide.destroy();
        }
    });

    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={"/informacion_general"}>
                            Información general
                        </Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p className="ff-FuturaMedium">
                            Grupos finalizados en el período
                        </p>
                    </div>
                </div>
            </div>
            {loading == false ? (
                <div className="slideInfo">
                    <div className="slideInfo--container">
                        <Search setQuestion={setNumber} type="info" />
                        <div className="slideInfo--title">
                            <p>GRUPO</p>
                            <div className="separator--hor mt-half mb-octa"></div>
                        </div>
                        {number == "" && arregloDeArreglos.length != 0 && (
                            <div className="glide sliderInfo">
                                <div
                                    data-glide-el="track"
                                    className="glide__track"
                                >
                                    <ul className="glide__slides sliderInfo--ul">
                                        {arregloDeArreglos.map(
                                            (arreglo, index) => (
                                                <li key={index}>
                                                    {arreglo.map(
                                                        (arr, indexarr) => (
                                                            <p key={indexarr}>
                                                                {arr.Grupo}
                                                            </p>
                                                        )
                                                    )}
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                                <div className="separator--hor mt-half mb-octa"></div>
                                <div
                                    className="glide__arrows sliderInfo--arrows"
                                    data-glide-el="controls"
                                >
                                    <button
                                        className="glide__arrow glide__arrow--left"
                                        data-glide-dir="<"
                                    >
                                        <img src="/images/icons/arrow-left.svg" />
                                    </button>
                                    <div className="d-flex">
                                        Grupos{" "}
                                        <p className="de mb-0 mx-octa">
                                            {desde}
                                        </p>{" "}
                                        a{" "}
                                        <p className="a mb-0 mx-octa">
                                            {hasta}
                                        </p>{" "}
                                        de {parrafos}
                                    </div>
                                    <button
                                        className="glide__arrow glide__arrow--right"
                                        data-glide-dir=">"
                                    >
                                        <img src="/images/icons/arrow-right.svg" />
                                    </button>
                                </div>
                            </div>
                        )}

                        {number != "" && arregloDeArreglos.length != 0 && (
                            <div className="glide sliderInfo">
                                <div
                                    data-glide-el="track"
                                    className="glide__track"
                                >
                                    <ul className="glide__slides sliderInfo--ul">
                                        {arregloDeArreglos.length != 0 &&
                                            arregloDeArreglos.map(
                                                (arreglo, index) => (
                                                    <li key={index}>
                                                        {arreglo.map(
                                                            (arr, indexarr) => (
                                                                <p
                                                                    key={
                                                                        indexarr
                                                                    }
                                                                >
                                                                    {arr.Grupo}
                                                                </p>
                                                            )
                                                        )}
                                                    </li>
                                                )
                                            )}
                                    </ul>
                                </div>
                                <div className="separator--hor mt-half mb-octa"></div>
                                <div
                                    className="glide__arrows sliderInfo--arrows"
                                    data-glide-el="controls"
                                >
                                    <button
                                        className="glide__arrow glide__arrow--left"
                                        data-glide-dir="<"
                                    >
                                        <img src="/images/icons/arrow-left.svg" />
                                    </button>
                                    <div className="d-flex">
                                        Grupos{" "}
                                        <p className="de mb-0 mx-octa">
                                            {desde}
                                        </p>{" "}
                                        a{" "}
                                        <p className="a mb-0 mx-octa">
                                            {hasta}
                                        </p>{" "}
                                        de {parrafos}
                                    </div>
                                    <button
                                        className="glide__arrow glide__arrow--right"
                                        data-glide-dir=">"
                                    >
                                        <img src="/images/icons/arrow-right.svg" />
                                    </button>
                                </div>
                            </div>
                        )}
                        {arregloDeArreglos.length == 0 && number != "" && (
                            <p>No se encontraron grupos relacionados.</p>
                        )}
                        {arregloDeArreglos.length == 0 && number == "" && (
                            <p>Por el momento no hay grupos finalizados.</p>
                        )}
                    </div>
                </div>
            ) : (
                <div
                    className="spinner-border text-rojo mt-base align-self-center my-base"
                    role="status"
                >
                </div>
            )}
        </div>
    );
};
